import React from 'react';
import {useDispatch} from 'react-redux';
import {ELEMENT} from '../../../../../incase-domain/elements/base/ElementTypes';
import {IElementVideo} from '../../../../../incase-domain/elements/video';
import {setSelectedElementId} from '../../../../../store/actions/slide';
import {useSetHighlightedElement} from '../../../../../utils/hooks/slideUpdates/useSetSlideElement';
import BaseVideoElementModal from './BaseVideoElementModal';

interface VideoElementModalProps {
    element: IElementVideo;
}

function VideoElementModal(props: VideoElementModalProps): JSX.Element {
    const dispatch = useDispatch();

    const {element} = props;
    const updateElement = useSetHighlightedElement();

    function onConfirm(videoSrc: IElementVideo['videoSource']): void {
        updateElement.multiple<IElementVideo>(['videoSource'], [videoSrc]);
        dispatch(setSelectedElementId(undefined));
    }

    return (
        <BaseVideoElementModal
            defaultSrc={element.videoSource}
            isOpen={element.type === ELEMENT.VIDEO}
            onCancel={() => {
                dispatch(setSelectedElementId(undefined));
            }}
            onConfirm={onConfirm}
        />
    );
}

export default VideoElementModal;
